import { makeStyles } from '@material-ui/core'

export const useStyles = (iconColor: string) =>
  makeStyles((theme) => {
    return {
      icon: {
        height: '14px !important',
        width: '14px !important',
        borderRadius: '90%',
        border: `1px solid ${iconColor}`,
        padding: theme.spacing(1.4),
        marginRight: theme.spacing(2),
        boxSizing: 'content-box',
        fill: theme.palette.primary.main,
      },
    }
  })
